export const LOGIN = '/api/auth/sign-in';
export const LOGOUT = '/api/auth/logout';
export const REFRESHTOKEN = '/api/auth/refreshtoken';
